import { render, staticRenderFns } from "./NotYet.vue?vue&type=template&id=23d0ee18&scoped=true&"
import script from "./NotYet.vue?vue&type=script&lang=js&"
export * from "./NotYet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d0ee18",
  null
  
)

export default component.exports